import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import ErrorWrapper from 'assets/components/inputs/wrappers/ErrorWrapper';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple2 from 'assets/components/table/themes/Theme.Table.Simple.2';
import { getLocales } from 'assets/locales/Locale';
import { isEmpty } from 'lodash';
import { AccountReceivableForm } from '../../Finance.AccountReceivable.Hooks';

const FinanceAccountReceivableEditStatements = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<AccountReceivableForm>();

  if (isEmpty(form.data?.statementCandidates)) return <ErrorWrapper children={lang.noInfo} />;

  return (
    <FormWrapper>
      <table className={ThemeTableSimple2}>
        <thead>
          <tr>
            <th>{lang.statement}</th>
            <th>{lang.totalAmount}</th>
            <th>{lang.amountDifference}</th>
            <th>{lang.dealerName}</th>
            <th>{lang.dealerNameSimilarityScore}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <DataMap
            data={form.data?.statementCandidates}
            render={({ data: score }) => {
              const currentStatement = form.data.statementCandidates?.find(
                (it) => it.statement?.id === score?.statement?.id
              );
              const hasAnotherSelected =
                form.data?.statementCandidates?.some(
                  (it) => it.isSelected && it.statement?.id !== score?.statement?.id
                ) ?? false;
              return (
                <tr key={score?.statement?.statementNumber}>
                  <td>{score?.statement?.statementNumber}</td>
                  <td>{score?.statement?.totalAmountDueCAD}</td>
                  <td>{score?.amountDifferenceInCAD}</td>
                  <td>{score?.statementDealer?.name}</td>
                  <td>{score?.dealerNameSimilarityScore}</td>
                  <td>
                    <Button
                      onClick={() => {
                        form.update({
                          statementCandidates: form.data?.statementCandidates?.map((it) => ({
                            ...it,
                            isSelected: it.statement?.id === score?.statement?.id ? !it.isSelected : it.isSelected,
                          })),
                        });
                      }}
                      class={ThemeButtonCircle}
                      media={<Icon class={currentStatement?.isSelected ? 'fas-check-square' : 'far-square'} />}
                      htmlElementProps={{
                        title:
                          !!form.data?.id && hasAnotherSelected
                            ? lang.cannotSelectMoreThanOneCandidate
                            : currentStatement?.isSelected
                              ? lang.unselect
                              : lang.select,
                      }}
                      disabled={!!form.data?.id && hasAnotherSelected}
                    />
                  </td>
                </tr>
              );
            }}
          />
        </tbody>
      </table>
    </FormWrapper>
  );
};

export default FinanceAccountReceivableEditStatements;
